class Templating {
    static baseColor = getComputedStyle(document.documentElement).getPropertyValue('--colorBrand');

    static loadVueCss(config) {
        // Slouží pro dynamické nahrávání stylů z zkompilovaných .vue (SFC) komponent.
        var head = document.getElementsByTagName('head')[0];

        if (config.content) {
            var style = document.createElement('style');
            if (style.styleSheet) {
                style.styleSheet.cssText = config.content;
            } else {
                style.innerHTML = config.content;
            }
            head.appendChild(style);
        } else if (config.url) {
            var link = document.createElement('link');
            link.href = config.url;
            link.rel = 'stylesheet';
            link.type = 'text/css';
            head.appendChild(link);
        }
    };

    static initVueComponents() {
        document.addEventListener("DOMContentLoaded", function() {
            document.querySelectorAll('[data-vue-component]:not([data-initialized])').forEach(rootContainer => {
                const componentClassFunc = Function('return VueComponents.' + rootContainer.dataset.vueComponent);
                try {
                    rootContainer.setAttribute('data-initialized', '');
                    const componentClass = componentClassFunc();
                    const props = rootContainer.dataset.props ? JSON.parse(rootContainer.dataset.props) : {};
                    for (const propName in rootContainer.dataset) {
                        if (rootContainer.dataset.hasOwnProperty(propName)) {
                            if (propName !== 'vueComponent' && propName !== 'initialized' && propName !== 'props') {
                                if (!(propName in props)) {
                                    props[propName] = rootContainer.dataset[propName];
                                }
                            }
                        }
                    }
                    Vue.createApp(componentClass, props).mount(rootContainer);
                } catch (e) {
                    console.error(e);
                }
            });
        });
    }
}
